import styled from "styled-components";

export const MainWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ececec;
`;

export const VideoBackground = styled.video`
    position: absolute;
    right: 0;
    top: 0;
    min-width: 100%;
    background-color: #ececec;
    min-height: 100%;
    width: 100%;
    height: auto;
    background-size: cover;
    object-fit: cover;
  @media (max-width: 1400px){
    
  }
  @media (max-width: 991px){
    display: none;
  }
`;

export const PictureBackground = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    min-width: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #ececec;
    
`;


export const VideoBackgroundMobile = styled.div`
  position: absolute;
  background-size: cover;
  background-position: bottom center;
  background-color: #ececec;
  background-repeat: no-repeat;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
    height: auto;
  min-width: 100%;
    min-height: 100%;
  object-fit: cover;
  @media (min-width: 992px){
    display: none;
  }
`;

